import { ClientPod, RosterRequestGroup } from '../generated/graphql';

/**
 * Returns the appropriate field label based on client pod for Control #/THS PO # fields
 */
export const getControlFieldLabelForPod = (
  clientPod?: ClientPod | null,
): string => {
  if (clientPod === ClientPod.Energy || clientPod === ClientPod.Other) {
    return 'THS PO #';
  }
  return 'Control #';
};

/**
 * Returns the appropriate placeholder text based on client pod for Control #/THS PO # fields
 */
export const getControlFieldPlaceholderForPod = (
  clientPod?: ClientPod | null,
): string => {
  if (clientPod === ClientPod.Energy || clientPod === ClientPod.Other) {
    return 'Enter THS PO #';
  }
  return 'Enter Control #';
};

/**
 * Returns the appropriate group options based on client pod for request filters
 */
export const getGroupOptionsForPod = (
  clientPod?: ClientPod | null,
): RosterRequestGroup[] => {
  if (clientPod === ClientPod.Energy || clientPod === ClientPod.Other) {
    return [RosterRequestGroup.Ths, RosterRequestGroup.Client];
  }

  // Government Solutions gets all options including the new JLOC
  if (clientPod === ClientPod.GovernmentSolutions) {
    return [
      RosterRequestGroup.J4Lodging,
      RosterRequestGroup.Ths,
      RosterRequestGroup.Jloc,
      RosterRequestGroup.Procurement,
    ];
  }

  // Default fallback for any other pod types
  return [
    RosterRequestGroup.J4Lodging,
    RosterRequestGroup.Ths,
    RosterRequestGroup.Jloc,
    RosterRequestGroup.Procurement,
  ];
};
